import axios from 'axios';

const STORAGE_KEY = 'sparrow_visitor_id';
const MAX_DWELL_SEC = 1800;

function visitorId() {
  try {
    let id = sessionStorage.getItem(STORAGE_KEY);
    if (!id) {
      id = `v_${Math.random().toString(36).slice(2, 12)}${Date.now().toString(36)}`;
      sessionStorage.setItem(STORAGE_KEY, id);
    }
    return id.slice(0, 64);
  } catch (e) {
    return `v_${Date.now()}`;
  }
}

function flushSession(current, endedAtMs) {
  if (!current) return;
  const rawSec = Math.round((endedAtMs - current.startedAt) / 1000);
  const dwellSeconds = Math.min(MAX_DWELL_SEC, Math.max(0, rawSec));
  if (dwellSeconds < 1) return;
  const payload = {
    visitorKey: visitorId(),
    path: current.fullPath,
    routeName: current.name || '',
    dwellSeconds,
  };
  axios
    .post('/api/user/analytics/page-session', payload, { timeout: 8000 })
    .catch(() => {});
}

function beaconFlush(current, endedAtMs) {
  if (!current) return;
  const rawSec = Math.round((endedAtMs - current.startedAt) / 1000);
  const dwellSeconds = Math.min(MAX_DWELL_SEC, Math.max(0, rawSec));
  if (dwellSeconds < 1) return;
  const payload = {
    visitorKey: visitorId(),
    path: current.fullPath,
    routeName: current.name || '',
    dwellSeconds,
  };
  const url = `${window.location.origin}/api/user/analytics/page-session`;
  const body = JSON.stringify(payload);
  try {
    if (navigator.sendBeacon) {
      const ok = navigator.sendBeacon(url, new Blob([body], { type: 'application/json' }));
      if (ok) return;
    }
  } catch (e) {
    /* fall through */
  }
  fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body,
    keepalive: true,
  }).catch(() => {});
}

/**
 * Tracks SPA route dwell time (anonymous visitor key + user when JWT is sent on in-app navigation).
 */
export function installSiteAnalytics(router) {
  if (!router || typeof router.afterEach !== 'function') return;

  let current = null;

  router.afterEach((to) => {
    const now = Date.now();
    flushSession(current, now);
    current = {
      fullPath: to.fullPath || '/',
      name: to.name || '',
      startedAt: now,
    };
  });

  window.addEventListener('pagehide', () => {
    if (current) {
      beaconFlush(current, Date.now());
    }
  });
}
